module.exports = __webpack_public_path__ + "static/img/讯飞AI会议耳机Pro 2.baa46bcd.png";